import { ChatRole } from 'types/index'

type UserProps = {
  userId: string | null
  userToken: string | null
  chatRole: ChatRole | null
}

/**
 * Get user token from URL query params
 */
export const getUserToken = (): string => {
  const searchParams = new URLSearchParams(window.location?.search)
  return searchParams.get('token') ?? ''
}

/**
 * Get user id from URL query params
 */
export const getUserId = (): string => {
  const searchParams = new URLSearchParams(window.location?.search)
  return searchParams.get('userId') ?? ''
}

/**
 * Get chat role from URL query params
 */
export const getChatRole = (): ChatRole | null => {
  const searchParams = new URLSearchParams(window.location?.search)
  return searchParams.get('chatRole') as ChatRole
}

// export const getBotMode = (): BotMode => {
//   const searchParams = new URLSearchParams(window.location?.search)
//   return searchParams.get('mode') as BotMode
// }

// /**
//  * Get language from URL query params
//  */
// export const getLang = (): string => {
//   const lang = new URLSearchParams(window.location?.search).get('lang') ?? ''
//
//   return lang ?? DEFAULT_LANGUAGE
// }

/**
 * Get user props from URL query params
 */
export const getUserProps = (): UserProps => {
  const userId = getUserId()
  const userToken = getUserToken()
  const chatRole = getChatRole()

  return {
    userId,
    userToken,
    chatRole: chatRole as UserProps['chatRole'],
  }
}
